import React from 'react';
import { Route, Switch } from 'react-router-dom';
import HomePage from './components/home/index';
import GalleryIndex from './components/gallery/index';
import NotFoundPage from './components/not-found/index';

export default () => (
  <Switch>
    <Route exact path="/" component={HomePage} />
    <Route path="/videos/:id([a-f\d]{24})" component={GalleryIndex} />
    <Route path="*" component={NotFoundPage} />
  </Switch>
);




// WEBPACK FOOTER //
// ./src/client/Routes.js